import { Component, Inject, Optional } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  AppWrapperComponent,
  AuthService,
  MetadataService,
  AppState,
  ProductService,
  GoogleAnalyticsService,
  LoadingState,
  NavbarConfigService,
  RouterEventsService,
  SelectedCustomerService,
  NavigationConfig,
  BaseViewConfigService,
  GungVersionValidatorService,
  GungModalService
} from 'gung-standard';
import { first } from 'rxjs';
import { RefSystemSettingsService } from '../../services/ref-system-settings.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GungListRouterEventsService } from "gung-list";
import { TranslateService } from "@ngx-translate/core";
import { GungLanguageConfigService } from 'gung-common';

@Component({
    selector: 'ref-wrapper',
    templateUrl: './ref-wrapper.component.html',
    styleUrls: ['./ref-wrapper.component.scss'],
    standalone: false
})
export class RefWrapperComponent extends AppWrapperComponent {

  constructor(
    store: Store<AppState>,
    authService: AuthService,
    productService: ProductService,
    metadataService: MetadataService,
    googleAnalyticsService: GoogleAnalyticsService,
    navbarConfigService: NavbarConfigService,
    private refSystemSettingsService: RefSystemSettingsService,
    router: Router,
    routerEventsService: RouterEventsService,
    protected gungListRouterEventsService: GungListRouterEventsService,
    protected route: ActivatedRoute,
    protected translate: TranslateService,
    protected selectedCustomerService: SelectedCustomerService,
    protected gungLanguageConfigService: GungLanguageConfigService,
    @Optional()
    @Inject('environment')
    protected environment: NavigationConfig,
    protected baseViewConfigService: BaseViewConfigService,
    protected gungVersionValidatorService: GungVersionValidatorService,
    protected modalService: GungModalService
  ) {
    super(
      store,
      authService,
      productService,
      metadataService,
      googleAnalyticsService,
      navbarConfigService,
      router,
      routerEventsService,
      gungListRouterEventsService,
      route,
      translate,
      selectedCustomerService,
      gungLanguageConfigService,
      environment,
      baseViewConfigService,
      gungVersionValidatorService,
      modalService
    );
  }

  protected subscribeToState() {
    super.subscribeToState();
    this.subscribeSettings();
  }

  protected subscribeSettings() {
    this.states.systemSettingsLoaded = LoadingState.LOADING;
    this.refSystemSettingsService
      .initColorMap()
      .pipe(first())
      .subscribe(() => {
        this.states.systemSettingsLoaded = LoadingState.VALID;
        this.updateAppState();
      });
  }
}
